import { seriesColor } from './scale'

const WIDTH = 88
const HEIGHT = 22

/**
 * A trend small enough to sit in a table cell.
 *
 * No axis, no labels, no tooltip: it answers "rising, falling, or flat" and nothing else, and the row
 * it sits in already carries the exact figures. Adding a scale to it would make it a bad chart rather
 * than a good glyph.
 *
 * Scaled to its own maximum, so it shows the shape of one device's fortnight rather than that
 * device's size relative to the others. That is deliberate but easy to misread, which is why the
 * column is headed with what it is and the accessible label says the range out loud.
 */
export function Sparkline({ values, label }: { values: number[]; label: string }) {
  if (values.length < 2) return <span className="muted">—</span>

  const highest = Math.max(...values, 1)
  const step = WIDTH / (values.length - 1)
  const points = values
    .map((value, index) => `${index * step},${HEIGHT - 2 - (value / highest) * (HEIGHT - 4)}`)
    .join(' ')

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      className="sparkline"
      role="img"
      aria-label={`${label}: ${values.join(', ')}`}
    >
      <polyline
        points={points}
        fill="none"
        stroke={seriesColor(0)}
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  )
}
